import { IDateTypes } from '../../types'

export const DATE_OPTIONS = [
  {
    label: 'Any Day',
    value: IDateTypes.anyDay,
  },
  {
    label: 'Specific Pickup Date',
    value: IDateTypes.specificDates,
  },
  {
    label: 'Days of Week',
    value: IDateTypes.daysOfWeek,
  },
]
